module.exports = __webpack_public_path__ + "img/fav.06964b22.png";